export enum PreferredContactMethodType {
  Call = '1',
  Text = '2',
  Address = '3',
  Website = '4'
}
